import { render, staticRenderFns } from "./GroupEntity.vue?vue&type=template&id=3344ac8e&"
import script from "./GroupEntity.vue?vue&type=script&lang=js&"
export * from "./GroupEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports